import React, { useEffect, useState } from "react";
import Breadcrumbs from "../layout/breadcrumb";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import "./approval.css";
import Close from "../../assets/Images/close.png";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Filter from "../../assets/Icons/filter.png";
import dummy from "../../assets/Images/dummy.png";
import { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";
import { DPR_API } from "../../services/apiCalls/dprApiCalls";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ExcelExport from "../../compnenets/commons/xls";
import ManpowerList from "../dpr/resources/manpower-list";
import PdfGenerator from "../pdf";

export default function MyApproval() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  // const [dprData, setDprData] = useState([]);
  const [approveData, setApproveData] = useState("");
  const [remark, setRemark] = useState("");
  const [user, setUser] = useState("");
  const [dprFilter, setDprFilter] = useState({
    DPRName: "",
    DPRType: "",
    StartDate: "",
    EndDate: "",
    DateRange: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDprFilter((prev) => ({ ...prev, [name]: value }));
  };
  const [openReferBack, setReferBack] = useState(false);
  const [approvalList, setApprovalList] = useState([]);
  const onOpenModal = (row) => {
    setApproveData(row);
    setOpen(true);
  };

  const onCloseModal = () => setOpen(true);

  const [openFilter, setOpenFilter] = useState(false);
  const onCloseModalFilter = () => setOpenFilter(true);
  const onCloseModalRefer = () => setReferBack(true);

  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "machinery resources",
    sheet: "Machinry",
  });

  const formatValue = (value) => {
    if (value === null || value === "") {
      return "NA";
    }
    return value;
  };

  const entries = Object.entries(approveData);

  const getMyApprovals = async () => {
    let state = JSON.parse(localStorage.getItem("state"));
    let dateRange = "";
    if (dprFilter?.StartDate && dprFilter?.EndDate) {
      let date1 = new Date(dprFilter?.StartDate);
      let date2 = new Date(dprFilter?.EndDate);
      let Difference_In_Time = date2.getTime() - date1.getTime();
      let Difference_In_Days = Math.round(
        Difference_In_Time / (1000 * 3600 * 24)
      );
      dateRange = Difference_In_Days;
    }

    let Obj = {
      UserID: state?.user?.user_id,
      //Filter Optinoal
      DPRName: dprFilter?.DPRName,
      DPRType: dprFilter?.DPRType,
      StartDate: dprFilter?.StartDate,
      EndDate: dprFilter?.EndDate,
      DateRange: dateRange,
    };
    const apprl = await DPR_API?.GetDPRDetailsForApproval(Obj);
    if (apprl && apprl?.DPRListForApproval?.length) {
      setApprovalList(apprl?.DPRListForApproval);
    } else {
      setApprovalList([]);
    }
    setDprFilter({
      DPRName: "",
      DPRType: "",
      StartDate: "",
      EndDate: "",
      DateRange: "",
    });
  };

  const onFilter = async () => {
    getMyApprovals();
  };
 
  const onApprove = async (title) => {
    let obj = [
      {
        ProjectID: approveData?.ProjectID,
        WorkPackageGUID: approveData?.WorkPackageGUID,
        DPRApprovalStatus: title == "approve" ? "3" : "2",
        Remark: remark,
        UserID: user.user_id,
        DPRID: approveData?.DPRID,
      },
    ];
    // console.log(obj);
    // return;
    const update = await DPR_API.UpdateDPRStatus(obj);
    if (update && update?.Status == 204) {
      toast.success(update?.Message, { autoClose: 2000 });
      setTimeout(() => {
        setReferBack(false);
        setOpen(false);
        getMyApprovals();
      }, 1500);
    }
  };

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("state"));
    setUser(user.user);
    getMyApprovals();
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(approvalList.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = approvalList.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );


  const projectDetailSS=()=>{
    return<>
           <div className="row">
            <div className="col-4"><div><span className="dpr-title">Project ID</span></div>
              <div> <span className="dpr-text">{approveData?.PO_No}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Project Name</span></div>
              <div> <span className="dpr-text">{approveData?.ProjectName}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Client</span></div>
              <div> <span className="dpr-text">{approveData?.ProjectOwnerName}</span></div>
            </div>
          </div>
          <div className="row">
            <div className="col-4"><div><span className="dpr-title">Location</span></div>
              <div> <span className="dpr-text">{approveData?.ProjectLocation?approveData?.ProjectLocation:"NA"}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Task</span></div>
              <div> <span className="dpr-text">{approveData?.Subtask?approveData?.Subtask:"NA"}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Work Package</span></div>
              <div> <span className="dpr-text">{approveData?.WorkPackage?approveData?.WorkPackage:"NA"}</span></div>
            </div>
          </div><div className="row">
            <div className="col-4"><div><span className="dpr-title">Weightage</span></div>
              <div> <span className="dpr-text">{approveData?.Weightage} %</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Initial Scope</span></div>
              <div> <span className="dpr-text">{approveData?.InitialScope}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Final Scope</span></div>
              <div> <span className="dpr-text">{approveData?.FinalScope}</span></div>
            </div>
          </div><div className="row">
            <div className="col-4"><div><span className="dpr-title">UOM</span></div>
              <div> <span className="dpr-text">{approveData?.UOM?approveData?.UOM:"NA"}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Prev. Progress</span></div>
              <div> <span className="dpr-text">{approveData?.PreviousProgress}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Today’s Progress</span></div>
              <div> <span className="dpr-text">{approveData?.TodayProgress}</span></div>
            </div>
          </div><div className="row">
            <div className="col-4"><div><span className="dpr-title">Cumulative</span></div>
              <div> <span className="dpr-text">{approveData?.Cumulative}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Progress %</span></div>
              <div> <span className="dpr-text">{approveData?.ProgressPercentage}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Weighted Progress</span></div>
              <div> <span className="dpr-text">{approveData?.WeightedProgress} %</span></div>
            </div>
          </div><div className="row">
            <div className="col-4"><div><span className="dpr-title">Balance Scope</span></div>
              <div> <span className="dpr-text">{approveData?.BalanceScope}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Planned Start</span></div>
              <div> <span className="dpr-text">{approveData?.PlannedStart?approveData?.PlannedStart:"NA"}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Planned Finish</span></div>
              <div> <span className="dpr-text">{approveData?.PlannedFinish?approveData?.PlannedFinish:"NA"}</span></div>
            </div>
          </div><div className="row">
            <div className="col-4"><div><span className="dpr-title">Scope Chart</span></div>
              <div> <span className="dpr-text opens">Open</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Current Rate</span></div>
              <div> <span className="dpr-text">{approveData?.CurrentRate}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Asking Rate</span></div>
              <div> <span className="dpr-text">{approveData?.AskingRate}</span></div>
            </div>
          </div><div className="row">
            <div className="col-4"><div><span className="dpr-title">Actual Start</span></div>
              <div> <span className="dpr-text">{approveData?.ActualStart?approveData?.ActualStart:"NA"}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Actual Finish</span></div>
              <div> <span className="dpr-text">{approveData?.ActualFinish?approveData?.ActualFinish:"NA"}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Expected Finish</span></div>
              <div> <span className="dpr-text">{approveData?.ExpectedFinish?approveData?.ExpectedFinish:"NA"}</span></div>
            </div>
          </div><div className="row">
            <div className="col-4"><div><span className="dpr-title">Status</span></div>
              <div> <span className="dpr-text">{approveData?.DPRApprovalStatus?approveData?.DPRApprovalStatus:"NA"}</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Resources</span></div>
              <div> <span className="dpr-text opens">open</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Risk</span></div>
              <div> <span className="dpr-text opens">open</span></div>
            </div>
          </div><div className="row">
            <div className="col-4"><div><span className="dpr-title">Issue</span></div>
              <div> <span className="dpr-text opens">open</span></div>
            </div>
            <div className="col-4"><div><span className="dpr-title">Picture</span></div>
              <div className="d-flex"> 
                <div>
                <img src={approveData?.UploadPicture?approveData?.UploadPicture:dummy} width={15}/>
                </div>
                <div className="mx-1">
                <span className="dpr-text">IMG.54541</span>
                  </div>
              </div>
            </div>
          </div>

    </>
  }

  return (
    <React.Fragment>
      {/* <PdfGenerator/> */}
       <Modal open={false} onClose={onCloseModal} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="allowcate">DPR Details</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
          <ManpowerList subId={173}/>
        <hr/>
        <div className="row mt-2">
         
        </div>
      </Modal>


      <div className="pb-0">
        <Breadcrumbs title="My Approval" menu="" link="My approval" />
      </div>
      <div className="row" style={{ marginRight: 25 }}>
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport
              data={approvalList}
              fileName="My approval"
              sheet="My approval"
            />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpenFilter(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div
            className="my-auto"
            onClick={() => {
              getMyApprovals();
            }}
          >
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div>
      <div className="table-container">
        <table className="custom-table">
          <thead className="table-header">
            <tr>
              <th>Sr No</th>
              <th>Work Package Name</th>
              <th>DPR Name</th>
              <th>DPR Type</th>
              <th>Site Engineer/ Contractor</th>
              <th>DPR Status</th>
              <th>PO Number</th>
              <th>Project Name</th>
              <th>Project Number</th>
              <th>PO Date</th>
              <th>DPR Creation Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td id="elps">{index + 1}</td>
                <td id="elps" title={row.WorkPackage}>
                  {row.WorkPackage}
                </td>
                <td id="elps" title={row.Subtask}>
                  {row.Subtask}
                </td>
                <td id="elps" title={row.DPRType}>
                  {row.DPRType ? row.DPRType : "-"}
                </td>
                <td id="elps" title={row.SiteEngineer_Contractor}>
                  {row.SiteEngineer_Contractor}
                </td>
                <td id="elps" title={row.DPRApprovalStatus}>
                  {row.DPRApprovalStatus}
                </td>
                <td id="elps" title={row.PO_No}>
                  {row.PO_No}
                </td>
                <td id="elps" title={row.ProjectName}>
                  {row.ProjectName}
                </td>
                <td id="elps" title={row.Project_Number}>
                  {row.Project_Number}
                </td>
                <td id="elps" title={row.PO_Date}>
                  {row.PO_Date}
                </td>
                <td id="elps" title={row.CreatedOn}>
                  {row.CreatedOn}
                </td>
                <td
                  onClick={() => onOpenModal(row)}
                  style={{ cursor: "pointer" }}
                >
                  ...
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div
          className="pagination"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 15px",
          }}
        >
          <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            Showing{" "}
            {Math.min((currentPage - 1) * rowsPerPage + 1, approvalList.length)}{" "}
            to {Math.min(currentPage * rowsPerPage, approvalList.length)} of{" "}
            {approvalList.length} entries
          </div>
          <div
            className="pagination-buttons"
            style={{
              fontSize: "14px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "5px",
            }}
          >
            {/* Left Arrow */}
            <button
              onClick={() => handleClick(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={leftArrow} // Replace with your actual image path
                alt="Previous"
                height="11px"
                width="7px"
                style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
              />
            </button>
            {/* Page Numbers */}
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => handleClick(i + 1)}
                style={{
                  background: currentPage === i + 1 ? "#00B69B" : "transparent",
                  color: currentPage === i + 1 ? "#fff" : "#000",
                  border: "none",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {i + 1}
              </button>
            ))}
            {/* Right Arrow */}
            <button
              onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={rightArrow} // Replace with your actual image path
                alt="Next"
                height="11px"
                width="7px"
                style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
              />
            </button>
          </div>
        </div>
      </div>
   <div id="dpr-data">
   <Modal open={open} onClose={onCloseModal} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="allowcate">DPR Details</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />

        <div className="container mt-4">
                  {projectDetailSS()}
        </div>
        <hr/>
        <div className="row mt-2">
          
          
          

          <div className="d-flex justify-content-center">
            {/* <button
              className="btn btn-warning shadow-none"
              onClick={() => {
                let data = {
                  WorkPackageID: approveData?.WorkPackageGUID,
                  WorkPackageName: approveData?.WorkPackage,
                  Project_Name: approveData?.ProjectName,
                  ProjectGUID: approveData?.ProjectGUID,
                  ProjectOwnerName: approveData?.ProjectOwnerName,
                };
                let fdata = { ...approveData, ...data };
                navigate("/dpr", { state: fdata });
              }}
            >
              Preview
            </button>
            &nbsp; */}
            <button
              className="btn btn-primary"
              onClick={() => onApprove("approve")}
            >
              Approve
            </button>
            &nbsp;
            <button
              className="btn btn-danger"
              onClick={() => setReferBack(true)}
            >
              Refer back
            </button>
          </div>
        </div>
      </Modal>
   </div>
      <Modal open={openFilter} onClose={onCloseModalFilter} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">My Approval Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpenFilter(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    value={dprFilter?.StartDate}
                    onChange={handleChange}
                    name="StartDate"
                    type="date"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    value={dprFilter?.EndDate}
                    onChange={handleChange}
                    name="EndDate"
                    type="date"
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Project name</label>
                  <input type="text" className="form-control shadow-none" />
                </div>
                <div className="col-6">
                  <label className="filter-label">Recently Added Project</label>
                  <select
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select</option>
                  </select>
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">DPR Name</label>
                  <input
                    type="text"
                    value={dprFilter?.DPRName}
                    name="DPRName"
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Recently Added DPR</label>
                  <select
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select</option>
                  </select>
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Site Enginner Name</label>
                  <input type="text" className="form-control shadow-none" />
                </div>
                <div className="col-6">
                  <label className="filter-label">DPR Type</label>
                  <select
                    className="filter-label"
                    value={dprFilter?.DPRType}
                    onChange={handleChange}
                    name="DPRType"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select</option>
                  </select>
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Project Status</label>
                  <select
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">My Approval</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option>ASC</option>
                <option>DES</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: 20 }}>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Role"
              value="option1"
            />
            <label for="Role" style={{ fontSize: 14 }}>
              PO Number
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Type"
              value="option1"
            />
            <label for="Type" style={{ fontSize: 14 }}>
              PO Date
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Created"
              value="option1"
            />
            <label for="Created" style={{ fontSize: 14 }}>
              DPR Creation Date
            </label>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4 pb-4">
          <button className="btn btn-primary" onClick={onFilter}>
            Filter
          </button>
        </div>
      </Modal>
      {/* Refer back */}
      <Modal open={openReferBack} onClose={onCloseModalRefer} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Refer Back </span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setReferBack(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12">
            <label className="filter-label">Comment</label>
            <textarea
              onChange={(e) => {
                setRemark(e.target.value);
              }}
              className="form-control shadow-none"
            />
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => onApprove("refer")}
          >
            Submit
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
}
